import {
  faBriefcase,
  faCalendar,
  faEdit,
  faFile,
  faFilePdf,
  faGlobeAmericas,
  faGraduationCap,
  faHandPointRight,
  faPhone,
  faTrash,
  faUser,
  faUsersCog,
} from "@fortawesome/free-solid-svg-icons";
import "../style/style-cv-1.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ProgressBar, Table } from "react-bootstrap";
import { Link } from "react-router-dom";
export default function CVTemplate2(propos) {
  return (
    <div className="row">
      <div className="col-sm-4 left-co">
        <div className="left-side" style={{ height: "100%" }}>
          <div className="profile-info">
            {propos.cv.photo != null ? (
              <img
                classNameName="img-fluid"
                src={
                  process.env.NODE_ENV === "production"
                    ? process.env.REACT_APP_API_BASE_URL_PROD +
                      `/storage/images/${propos.cv.photo}`
                    : process.env.REACT_APP_API_BASE_URL_LOCAL +
                      `storage/images/${propos.cv.photo}`
                }
                style={{
                  border: "1px solid #4d4545",
                  width: "100%",
                  height: "auto",
                }}
              />
            ) : (
              <FontAwesomeIcon
                icon={faUser}
                style={{
                  border: "1px solid #4d4545",
                  width: "100%",
                  height: "auto",
                }}
              />
            )}
            <p style={{ fontWeight: "bold" }}> #{propos.cv.id}</p>
            <p style={{ fontWeight: "700" }}>
              {" "}
              {propos.cv.civilite} : {propos.cv.nom}
            </p>
            <span style={{ fontWeight: "600" }}>
              {propos.cv.domain_d_etude}
            </span>
          </div>

          <h4 className="ltitle">Date de naissance</h4>
          <div className="contact-box ">
            <div className="icon">
              <FontAwesomeIcon
                className="fas-fa-in-side-feft-cv"
                icon={faCalendar}
              />
            </div>
            <div className="detail">
              {propos.cv.date_naissance} <br />
            </div>
          </div>

          <h4 className="ltitle">Contact</h4>
          <div className="contact-box ">
            <div className="icon">
              <FontAwesomeIcon
                className="fas-fa-in-side-feft-cv"
                icon={faPhone}
              />
            </div>
            <div className="detail">
              {propos.cv.telephone} <br />
            </div>
          </div>

          <div className="contact-box pb0">
            <div className="icon">
              <FontAwesomeIcon
                className="fas-fa-in-side-feft-cv"
                icon={faGlobeAmericas}
              />
            </div>
            <div className="detail">
              {propos.cv.email} <br />
            </div>
          </div>

          <h4 className="ltitle">Langue</h4>
          {propos.langues.map((langue, index) => (
            <div className="refer-cov" key={index}>
              <Table style={{ width: "100%" }}>
                <tbody>
                  <tr>
                    <td
                      style={{
                        width: "30%",
                        background: " #00ab9f",
                        color: "#fff",
                      }}
                    >
                      {" "}
                      <b>{langue.nom}</b>
                    </td>

                    <td
                      style={{
                        width: "2%",
                        background: " #00ab9f",
                        color: "#fff",
                      }}
                    >
                      <b>:</b>
                    </td>

                    <td
                      style={{
                        width: "45%",
                        background: " #00ab9f",
                        color: "#fff",
                      }}
                    >
                      <b>{langue.niveau}</b>
                    </td>
                    <td
                      style={{
                        width: "3%",
                        background: " #00ab9f",
                        color: "#fff",
                      }}
                    >
                      <Link
                        to="#"
                        onClick={() => propos.suprimerLangue(langue.id)}
                        style={{ marginLeft: "40px", fontSize: "0.7rem" }}
                      >
                        <FontAwesomeIcon
                          icon={faTrash}
                          className="fa-lg text-danger"
                        />
                      </Link>
                      <br />
                    </td>
                  </tr>
                </tbody>
              </Table>
            </div>
          ))}
        </div>
      </div>
      <div className="col-sm-8 rt-div">
        <div className="rit-cover" style={{ height: "100%" }}>
          {/* À propos de moi */}
          {propos.cv.description != "null" && propos.cv.description != null ? (
            <>
              <h2 className="rit-titl">
                <FontAwesomeIcon icon={faUser} /> À propos de moi{" "}
              </h2>
              <div className="about">
                <p>{propos.cv.description}</p>
              </div>
            </>
          ) : null}

          {/* Formations */}
          <h2 className="rit-titl">
            <FontAwesomeIcon icon={faGraduationCap} /> Formations{" "}
          </h2>
          <div className="education">
            <ul className="row no-margin">
              {propos.formations.map((formation, index) => (
                <li key={index} className="col-md-6">
                  <b>{formation.titre_formation}</b>
                  {formation.date_fin == null && formation.encoure == 1 ? (
                    <span> {formation.date_debut} - Encoure </span>
                  ) : (
                    <span>
                      {" "}
                      {formation.date_debut} - {formation.date_fin}{" "}
                    </span>
                  )}
                  <br />
                  {formation.specialite} - {formation.etablissement} -{" "}
                  {formation.ville}
                </li>
              ))}
            </ul>
          </div>

          {/* Experiences */}
          {propos.experiences.length === 0 ? null : (
            <>
              <h2 className="rit-titl">
                {" "}
                <FontAwesomeIcon icon={faBriefcase} /> Experiences
              </h2>
              {propos.experiences.map((experience, index) => (
                <div className="work-exp" key={index}>
                  <h6>
                    {experience.titre_projet}

                    <br />
                    {experience.date_fin == null && experience.encour == 1 ? (
                      <span> {experience.date_debut} - Encoure </span>
                    ) : (
                      <span>
                        {" "}
                        {experience.date_debut} - {experience.date_fin}{" "}
                      </span>
                    )}
                  </h6>
                  <i>{experience.nom_entreprise}</i>
                  {experience.description != null ? (
                    <ul>
                      <li>
                        <FontAwesomeIcon
                          icon={faHandPointRight}
                          style={{ marginRight: 5 }}
                        />
                        {experience.description}
                      </li>
                    </ul>
                  ) : null}
                </div>
              ))}
              <hr
                style={{
                  color: "#FF00FF",
                  backgroundColor: "#CCC",
                  height: "1px",
                  border: 0,
                  marginLeft: "480px",
                }}
              />
            </>
          )}

          {/* Compétences */}
          {propos.competences.length === 0 ? null : (
            <>
              <h2 className="rit-titl">
                {" "}
                <FontAwesomeIcon icon={faUsersCog} /> Compétences
              </h2>
              <div className="profess-cover row no-margin">
                {propos.competences.map((competence, index) => (
                  <div className="col-md-6" key={index}>
                    <div
                      className="row prog-row"
                      style={{ padding: "8px 11px" }}
                    >
                      <div className="col-12">
                        <span>{competence.nom}</span>
                        <Link
                          style={{ fontSize: "0.7rem", float: "inline-end" }}
                          to=""
                          onClick={() =>
                            propos.suprimerCompetence(competence.id)
                          }
                        >
                          <FontAwesomeIcon
                            icon={faTrash}
                            className="fa-lg text-danger"
                          />
                        </Link>
                      </div>
                      <div className="col-12">
                        <ProgressBar
                          now={competence.niveau}
                          label={`${competence.niveau}%`}
                          visuallyHidden
                        />
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </>
          )}

          {/* Documents */}
          {propos.piecejointes.length === 0 ? null : (
            <>
              <h2 className="rit-titl">
                {" "}
                <FontAwesomeIcon icon={faFile} /> Documents{" "}
              </h2>

              <div
                className="profess-cover row no-margin "
                style={{ marginLeft: "10px" }}
              >
                {propos.piecejointes.map((piecejointe, index) => (
                  <div key={index}>
                    <div
                      style={{
                        padding: "5px",
                        width: "90%",
                        display: "table-row",
                        verticalAlign: "inherit",
                        borderColor: "inherit",
                      }}
                    >
                      <FontAwesomeIcon icon={faFilePdf} />
                      <Link
                        className="text-primary"
                        target="_blank"
                        style={{ marginLeft: "10px" }}
                        to="#"
                      >
                        {piecejointe.nom}
                      </Link>
                    </div>
                    <div
                      style={{
                        padding: "5px",
                        width: "10%",
                        display: "table-row",
                        verticalAlign: "inherit",
                        borderColor: "inherit",
                      }}
                    >
                      <Link to="#">
                        <FontAwesomeIcon
                          icon={faTrash}
                          style={{ color: "red" }}
                        />
                      </Link>
                    </div>
                  </div>
                ))}
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
